import { useState } from 'react'
import { useSelector } from 'react-redux'
import { ColorSwatchesParams } from '~/app/features/Gallery/components/DesignTile/interface'
import { isPpagGallerySelector } from '~/app/store/config/reducer'
import { getIsColorSwatchesSimilarColors } from '~/app/utils/getColorSwatchColors'
import type { GalleryContentQuery } from 'shared/types/gallery/content-query'

export const useColorSwatches = (
  handleColorSwatchChange: (selectedValue: string) => void,
  maxColorSwatchesPerRow: number,
  colorSwatchObjects: GalleryContentQuery.ColorSwatch[],
): ColorSwatchesParams => {
  const [isExpanded, setIsExpanded] = useState(false)
  const isPpagGallery = useSelector(isPpagGallerySelector)

  const shouldShowColorSwatches = colorSwatchObjects.length > 1 && !isPpagGallery
  const onColorSwatchChangeWrapper = (selectedValue: string | number | null): void => {
    const stringifiedValue = selectedValue?.toString() || ''

    handleColorSwatchChange(stringifiedValue)
  }

  const handleClickShowMoreButton = (): void => {
    setIsExpanded((prevProps) => !prevProps)
  }

  const shouldShowShowMoreButton = maxColorSwatchesPerRow > 0 ? maxColorSwatchesPerRow < colorSwatchObjects.length : false

  const showMoreIcon = isExpanded ? 'caretUp' : 'caretDown'

  const isColorSwatchColorsSimilar = getIsColorSwatchesSimilarColors(colorSwatchObjects)

  return {
    shouldShowColorSwatches,
    onColorSwatchChangeWrapper,
    handleClickShowMoreButton,
    showMoreIcon,
    isExpanded,
    shouldShowShowMoreButton,
    isColorSwatchColorsSimilar,
  }
}
